export const getBasic = (userCode: string) => {
  return `<script src="https://cdn.userway.org/widget.js" data-account="${userCode}"></script>`;
};

export const getAdvanced = (userCode: string) => {
  return `<script>
    (function(d){
      var s = d.createElement("script");
      /* uncomment the following line to override default position*/
      /* s.setAttribute("data-position", 3);*/
      /* uncomment the following line to override default size (values: small, large)*/
      /* s.setAttribute("data-size", "small");*/
      /* uncomment the following line to override default language (e.g., fr, de, es, he, nl, etc.)*/
      /* s.setAttribute("data-language", "language");*/
      /* uncomment the following line to override color set via widget (e.g., #053f67)*/
      /* s.setAttribute("data-color", "#053e67");*/
      /* uncomment the following line to override type set via widget (1=person, 2=chair, 3=eye, 4=text)*/
      /* s.setAttribute("data-type", "1");*/
      /* s.setAttribute("data-statement_text:", "Our Accessibility Statement");*/
      /* s.setAttribute("data-statement_url", "http://www.example.com/accessibility")";*/
      /* uncomment the following line to override support on mobile devices*/
      /* s.setAttribute("data-mobile", true);*/
      /* uncomment the following line to set custom trigger action for accessibility menu*/
      /* s.setAttribute("data-trigger", "triggerId")*/
      /* uncomment the following line to override widget's z-index property*/
      /* s.setAttribute("data-z-index", 10001);*/
      /* uncomment the following line to enable Live site translations (e.g., fr, de, es, he, nl, etc.)*/
      /* s.setAttribute("data-site-language", "null");*/
      s.setAttribute("data-widget_layout", "full")
      s.setAttribute("data-account", "${userCode}");
      s.setAttribute("src", "https://cdn.userway.org/widget.js");
      (d.body || d.head).appendChild(s);
    })(document)
    </script>
    <noscript>Please ensure Javascript is enabled for purposes of <a href="https://userway.org">website accessibility</a></noscript>
  `;
};

export const getWhiteLabel = (userCode: string) => {
  return `<script>
    (function(d){
      var s = d.createElement("script");
      s.setAttribute("data-account", "${userCode}");
      s.setAttribute("src", "https://accessibilityserver.org/widget.js");
      (d.body || d.head).appendChild(s);
    })(document)
    </script>
    <noscript>Please ensure Javascript is enabled for purposes of <a href="https://accessibilityserver.org">website accessibility</a></noscript>
  `;
};

export const getEmbedVideoCode = (videolink: string, title: string) => {
  return `<iframe
  width="100%"
  height="100%"
  src="${videolink}"
  frameborder="0"
  title="${title}"
  allowfullscreen
></iframe>`;
};
